import { render, staticRenderFns } from "./SendPatientInviteModal.vue?vue&type=template&id=4ee395ce"
import script from "./SendPatientInviteModal.vue?vue&type=script&lang=js"
export * from "./SendPatientInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports